import { MutableRefObject, useState } from 'react';
import { Feature } from 'geojson';
import * as turf from '@turf/turf';
// @ts-expect-error mapbox-gl-draw has no types
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import MapButton from './MapButton';
import ConfirmationModal from '../../basics/ConfirmationModal';

const AnalyzeRegionButton = ({
  mapCenter,
  drawRef,
  parcels,
  setParcels,
}: {
  mapCenter: { lng: number; lat: number };
  drawRef: MutableRefObject<MapboxDraw | null>;
  parcels: Feature[];
  setParcels: (features: Feature[]) => void;
}) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [pendingAnalyzeRegion, setPendingAnalyzeRegion] = useState(false);
  const { lng, lat } = mapCenter;

  const createCircleParcel = () => {
    // Create a circular feature
    const circleFeature = turf.circle([lng, lat], 0.5, {
      units: 'miles',
    });
    // Set the drawn features to only the circle
    setParcels([circleFeature]);
  };

  const analyzeRegion = () => {
    if (!mapCenter || !drawRef.current) return;

    // Show confirmation modal if there are existing drawn features
    if (parcels.length > 0) {
      setIsConfirmationModalOpen(true);
      setPendingAnalyzeRegion(true);
      return;
    }
    createCircleParcel();
  };

  const handleConfirmAnalyzeRegion = () => {
    setIsConfirmationModalOpen(false);

    if (pendingAnalyzeRegion) {
      createCircleParcel();
      setPendingAnalyzeRegion(false);
    }
  };

  const handleCancelAnalyzeRegion = () => {
    setIsConfirmationModalOpen(false);
    setPendingAnalyzeRegion(false);
  };

  return (
    <>
      <MapButton onClick={analyzeRegion}>Analyze region</MapButton>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        actionDescriptionSentence="This action will remove existing parcels."
        actionQuestion="Do you want to continue?"
        actionName="replace parcels"
        onCancel={handleCancelAnalyzeRegion}
        onConfirm={handleConfirmAnalyzeRegion}
      />
    </>
  );
};

export default AnalyzeRegionButton;
